// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N1MY","questions":"styles_questions__ie-FL","footer":"styles_footer__27b11"};